import React, {useCallback, useState} from 'react';
import Autocomplete from 'react-autocomplete';

export const MIN_CHARACTER_LENGTH = 3;

const StoreFinderSearch = ({suburbsList, onUpdated, onSubmitted}) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchBtnStatus, setSearchBtnStatus] = useState('disabled');

  const sendSuburbsQuery = useCallback((searchLocation) => {
    if (searchLocation.length === MIN_CHARACTER_LENGTH) {
      onUpdated(searchLocation);
    }
  }, []);

  const updateSearchBtnStatus = useCallback((searchLocation) => {
    if (searchLocation.length > MIN_CHARACTER_LENGTH) {
      setSearchBtnStatus(false);
    }else{
      setSearchBtnStatus('disabled');
    }
  }, []);

  const handleSubmit = useCallback(event => {
    event.preventDefault();
    onSubmitted(document.querySelector("#suburb-autocomplete").value);
  }, []);

  const addExtraIndexColumn = (list) => {
    let counter = 0;
    list.forEach(function (item) {
      item.id = counter;
      counter ++;
    });
    return list;
  };

  return (
    <form className="popup-stock-check__content-form">
      <div className="store-search-block__input">
        <Autocomplete
          value={searchValue}
          inputProps={{id: 'suburb-autocomplete', type: 'search', placeholder: 'Enter suburb, city or postcode ...'}}
          wrapperStyle={{width: '100%'}}
          items={addExtraIndexColumn(suburbsList)}
          getItemValue={item => item.name + ' ' + item.postcode + ', ' + item.state}
          shouldItemRender={matchSuburb}
          onChange={(event, value) => {
            setSearchValue(value);
            sendSuburbsQuery(value);
            updateSearchBtnStatus(value);
          }}
          onSelect={(value) => {
            setSearchValue(value);
            updateSearchBtnStatus(value);
          }}
          renderMenu={children => (
            <div className="menu">
              {children}
            </div>
          )}
          renderItem={(item, isHighlighted) => (
            <div
              className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
              key={item.id}>
              {item.name + ' ' + item.postcode + ', ' + item.state}
            </div>
          )}
        />
      </div>
      <button className="store-search-block__button" disabled={searchBtnStatus} onClick={handleSubmit}>Search</button>
    </form>
  );
};

export const matchSuburb = (targetValue, inputValue) => {
  if (inputValue.length >= MIN_CHARACTER_LENGTH) {
    return (
      (targetValue.name + ' ' + targetValue.postcode + ', ' + targetValue.state).toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
    );
  }
};

export default StoreFinderSearch;